import { defineStore } from "pinia";
export const cards = defineStore("cards", {
  state: () => ({
    cardItem: [],
  }),
  actions: {
    getDataCard(item) {
      if (this.cardItem.some((cartItem) => cartItem.id === item.id)) {
        this.cardItem.find((cartItem) => cartItem.id === item.id).quantity +=
          item.quantity;
      } else {
        this.cardItem.push({ ...item });
      }

      localStorage.setItem("cart-items", JSON.stringify(this.cardItem));
      console.log(this.cardItem);
    },
    getCardLocalStorage() {
      if (localStorage.getItem("cart-items")) {
        this.cardItem = JSON.parse(localStorage.getItem("cart-items"));
      }
      console.log(this.cardItem);
    },
    deleteItem(itemId) {
      for (let i = 0; i < this.cardItem.length; i++) {
        if (this.cardItem[i].id === itemId) {
          this.cardItem.splice(i, 1);
          break;
        }
      }
      localStorage.setItem("cart-items", JSON.stringify(this.cardItem));
      console.log(this.cardItem);
    },
    getNewData() {
      localStorage.setItem("cart-items", JSON.stringify(this.cardItem));
    },
    resetItems() {
      this.cartItems = [];
      localStorage.removeItem("cart-items");
    },
    loadItemsFromLocalStorage() {
      const items = JSON.parse(localStorage.getItem("cart-items")) || [];
      this.cardItem = items; // تحديث حالة المتجر
    },
  },
});
